import { render, staticRenderFns } from "./DefaultBox.vue?vue&type=template&id=c801d62a&"
import script from "./DefaultBox.vue?vue&type=script&lang=js&"
export * from "./DefaultBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports